import {Span} from '@chakra-ui/react'

// The volume unit is always mL, so expose it as a fixed, non-interactive suffix
// instead of an editable unit select.
export const volumeUnitEndElement = (
  <Span paddingRight="1rem" userSelect="none" textStyle="xs" color="fg.subtle">
    mL
  </Span>
)
